<template>
    <div class="page" id="profile">
        <header class="pageHeader">
            <fade-image src="assets/headers/profile.png" />
        </header>

        <div id="scroller">
            <div class="pageHeaderIntro higher">
                <h1>
                    Hi <span class="capitalise">{{ user.first_name }}</span
                    >!
                </h1>
                <p data-cy="welcome">Welcome <span v-if="!firstVisit">back</span> to Lesson Pro</p>
                <img class="icon" src="~@/assets/icons/headers/profile.svg" />
            </div>

            <router-link
                id="nextLesson"
                :to="{ name: 'LessonChange', params: { id: next_lesson.id } }"
                v-if="next_lesson"
            >
                <span class="title">Next Lesson:</span>
                <span class="date" style="font-weight: 200">{{
                    $date(next_lesson.date).format("DD MMM")
                }}</span>
                <chevron-right-icon class="icon"></chevron-right-icon>
            </router-link>
            <router-link
                id="nextLesson"
                class="playerBookLessonProfile"
                :to="{ name: 'BookChooseType' }"
                v-else-if="$store.state.user.lesson_settings.video_lessons_enabled"
            >
                <span class="title">Book Lesson:</span>
                <img src="@/assets/book-lesson.svg" />
                <img class="arrow" src="@/assets/arrow-right-white-2.svg" />
            </router-link>
            <router-link
                id="nextLesson"
                class="playerBookLessonProfile"
                :to="{ name: 'BookLesson', query: { from: 'player' } }"
                v-else
            >
                <span class="title">Book Lesson:</span>
                <img src="@/assets/book-lesson.svg" />
                <img class="arrow" src="@/assets/arrow-right-white-2.svg" />
            </router-link>

            <router-link id="bag" :to="{ name: 'playerYardages' }">
                <span class="title">Your yardages:</span>
                <img src="@/assets/yardages.svg" />
                <img class="arrow" src="@/assets/arrow-right-white.svg" />
            </router-link>

            <span class="clear"></span>

            <home-content-ad />

            <span class="clear"></span>

            <empty-placeholder
                class="mt20"
                v-if="
                    reminders &&
                    reminders.length == 0 &&
                    user.skills.length == 0 &&
                    !user.last_lesson
                "
            >
                TIP! Key reminders, skill assessments and lesson records will appear here, get
                started and book your first lesson by tapping the button above.
            </empty-placeholder>

            <div class="playerRemindersWrapper" v-if="reminders && reminders.length > 0">
                <span class="title">Key Reminders: <img src="@/assets/icons/ribbon.svg" /></span>
                <div id="keyReminders" class="playerReminders">
                    <ul>
                        <reminder-item
                            v-for="reminder in reminders"
                            :reminder="reminder"
                            :key="reminder.id"
                        />
                    </ul>
                </div>
            </div>

            <skills-score v-if="user.skills_enabled && user.skills.length > 0" />

            <div class="lastLesson" v-if="user.last_lesson">
                <span class="title"
                    >Last lesson: <img src="@/assets/records-small-dark-green.svg"
                /></span>

                <ul class="lessonList">
                    <li class="historyLesson" :class="{ noRecord: !user.last_lesson.record }">
                        <router-link
                            :to="{ name: 'playerLesson', params: { id: user.last_lesson.id } }"
                        >
                            <span v-if="!user.last_lesson.record">
                                {{ $date(user.last_lesson.date).format("DD MMM YYYY") }}
                                <strong>Awaiting record update</strong>
                                <img class="recordArrow" src="@/assets/arrow-right-white-2.svg" />
                            </span>
                            <span v-else>
                                <b
                                    ><span v-if="!user.last_lesson.title">Untitled record</span
                                    ><span class="title" v-else>{{
                                        user.last_lesson.title
                                    }}</span></b
                                >
                                {{ $date(user.last_lesson.date).format("DD MMM YYYY") }}

                                <template v-if="user.last_lesson.start != user.last_lesson.end">
                                    {{
                                        $date("2020-12-08 " + user.last_lesson.start).format(
                                            "HH:mm",
                                        )
                                    }}
                                    -
                                    {{
                                        $date("2020-12-08 " + user.last_lesson.end).format("HH:mm")
                                    }}
                                </template>

                                <lesson-star :lesson="user.last_lesson" />
                                <img class="recordArrow" src="@/assets/arrow-right-white.svg" />
                            </span>
                        </router-link>

                        <lesson-locked-overlay
                            v-if="isLessonRecordLocked(user.last_lesson)"
                            :lesson="user.last_lesson"
                        />
                    </li>
                </ul>

                <upgrade-to-premium-button v-if="user.last_lesson && !isPremium" />
            </div>

            <ul id="tasks" class="proHomeTasks bottomTasks">
                <li class="bagLink">
                    <router-link :to="{ name: 'playerBag' }">
                        What's in the bag:
                        <img class="arrow" src="@/assets/arrow-right-green.svg" />
                        <img class="bag" src="@/assets/bag.svg" />
                    </router-link>
                </li>

                <li class="bagLink2">
                    <router-link :to="{ name: 'playerProProfile' }">
                        Your Lesson Pro:
                        <img class="arrow" src="@/assets/arrow-right-white-2.svg" />
                        <img class="prof" src="@/assets/profile.svg" />
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import LessonStar from "@/components/Player/Lessons/lesson-star";
import LessonLockedOverlay from "@/components/Player/Lessons/lesson-locked-overlay";
import ReminderItem from "@/components/Shared/Reminder-item";
import { ChevronRightIcon } from "vue-feather-icons";
import skillsScore from "@/components/Player/Skills-score";
import FadeImage from "@/components/App/fade-image";
import HomeContentAd from "@/components/App/home-content-ad";
import UpgradeToPremiumButton from "@/components/Player/upgrade-to-premium-button";
import lessonRecordAccess from "@/mixins/lesson-record-access";
export default {
    name: "player-profile",
    mixins: [lessonRecordAccess],
    components: {
        EmptyPlaceholder,
        LessonStar,
        LessonLockedOverlay,
        ReminderItem,
        FadeImage,
        HomeContentAd,
        skillsScore,
        ChevronRightIcon,
        UpgradeToPremiumButton,
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        next_lesson() {
            return this.$store.state.user.next_lesson;
        },
    },
    created() {
        this.getNextLesson();
        this.getLastLesson();
        this.getReminders();
        this.$store.dispatch("getUser");

        if (window.localStorage.getItem("first_visit")) {
            this.firstVisit = true;
            window.localStorage.removeItem("first_visit");
        }
    },
    data() {
        return {
            reminders: false,
            firstVisit: false,
        };
    },
    methods: {
        getNextLesson() {
            window.axios.get("/next_lesson").then((response) => {
                this.$store.state.user.next_lesson = response.data;
            });
        },
        getLastLesson() {
            window.axios.get("/last_lesson").then((response) => {
                this.$store.state.user.last_lesson = response.data;
            });
        },
        getReminders() {
            window.axios.get("/player/" + this.user.id + "/reminders").then((response) => {
                this.reminders = response.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#profile {
    .playerRemindersWrapper {
        margin-top: 20px;
        .title {
            margin-bottom: 10px;
            display: block;
            img {
                float: right;
            }
        }
        .info {
            padding-left: 0px;
            background: transparent;
            line-height: 23px;
            margin-bottom: 0px;
        }
    }
    .lastLesson {
        margin-top: 30px;
        margin-bottom: 30px;
        .title {
            margin-bottom: 10px;
            display: block;
            img {
                float: right;
            }
        }
    }
    .historyLesson {
        background: #eef5f2;
        border-radius: $radius;
        margin-bottom: 10px;
        padding: 17px 20px;
        position: relative;

        a {
            text-decoration: none;
            color: $green_0;
            font-weight: 200;
        }
        &.noRecord {
            background: $green_0;
            color: white;
            a {
                color: white;
            }
            strong {
                font-weight: 400;
                display: block;
                margin-top: 10px;
            }
        }
        b {
            font-weight: 400;
            margin-bottom: 10px;
            display: block;
        }
        .recordArrow {
            position: absolute;
            right: 15px;
            bottom: 20px;
            pointer-events: none;
        }
        .star {
            position: absolute;
            right: 35px;
            bottom: 14px;
            top: auto;
        }
    }
    .playerReminders {
        padding: 20px;
        margin-bottom: 10px;
        padding-top: 0px;
        padding-bottom: 0px;
    }
    #nextLesson,
    #bag {
        border-radius: 15px;
        margin-bottom: 10px;
        padding: 20px;
        position: relative;
        text-decoration: none;
        .icon {
            color: white;
            position: absolute;
            bottom: 10px;
            right: 10px;
        }
        .title {
            color: white;
            display: block;
            margin-bottom: 10px;
        }
    }
    #nextLesson,
    #bag {
        width: calc(50% - 5px);
        height: 124px;
        float: left;
        .date {
            color: white;
            font-size: 26px;
        }
    }
    #nextLesson {
        background: $green_1;
        margin-right: 10px;

        .calendar {
            width: 20px;
            color: $green_2;
            position: absolute;
            top: -5px;
            right: -5px;
        }
    }
    #bag {
        background-color: #eef5f2;
        .title {
            color: $green_0;
            margin-bottom: 20px;
        }
        .arrow {
            right: 20px;
            top: auto;
            bottom: 20px;
            position: absolute;
        }
    }

    .playerBookLessonProfile {
        .title {
            margin-bottom: 20px !important;
        }
        .arrow {
            right: 20px;
            top: auto;
            bottom: 20px;
            position: absolute;
        }
    }
}
</style>
